// extracted by mini-css-extract-plugin
module.exports = {"pagMesInfo":"codiespectador_pagMesInfo__e41NN","clickable":"codiespectador_clickable__ULQsj"};